export const INBOX_TAB_CHANGE = 'events/INBOX_TAB_CHANGE';

/**
 * @return {{type: string}}
 */
export const inboxTabChange = (value) => ({
  type: INBOX_TAB_CHANGE,
  payload: value,
});
